export class WorkspaceNetworkingSettingsVpcPeering {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cidrs",
            "baseName": "cidrs",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "VpcPeeringStatus",
            "format": ""
        },
        {
            "name": "peeringConnectionId",
            "baseName": "peeringConnectionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "createError",
            "baseName": "createError",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceNetworkingSettingsVpcPeering.attributeTypeMap;
    }
    constructor() {
    }
}
